import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuComponent } from '../menu/menu.component';
import { HttpSession } from 'src/app/libs/ruvpp-angular2-comun/HttpSession';

@Component({
    selector: 'app-portada-simulador-admin',
    templateUrl: './portada-simulador-admin.component.html',
    styleUrls: ['../../../assets/css/styles.css']
})
export class PortadaSimuladorAdminComponent implements OnInit {

    public usuario: string;
    public menu: MenuComponent;

    /**
     * 
     * @param _router
     */
    constructor(private _router: Router) {
        this.menu = new MenuComponent(_router);
    }

    ngOnInit(): void {
        this.usuario = HttpSession.getAttribute('USER_NAME');
    }

}
